export default "__VITE_ASSET__DH4c8VqZ__"